import React, { useCallback } from 'react';

import { View } from 'react-native';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

import gStyles from 'config/styles';

import { SCREEN } from 'router/screens';
import {
    RootTemplates,
    RouteNavigationParams,
    TEMPLATE_TO_PATHNAME,
    TEMPLATE_TO_ROUTE,
} from 'router/types';

import { setFocusToNow } from 'store/epg/actions';
import {
    MenuConfigurationItem,
    MenuItemType,
} from 'store/railsBuilder/reducer.types';
import { selectNavigationMenu } from 'store/railsBuilder/selectors';

import MainMenuItemWeb from './components/MainMenuItem.web';
import styles from './styles';

const RootNavigationHeaderCenter = () => {
    const dispatch = useDispatch();

    const tabs = useSelector(selectNavigationMenu);
    const navigation =
        useNavigation<
            StackNavigationProp<
                RouteNavigationParams,
                SCREEN.MODULAR_ROOT | SCREEN.EPG
            >
        >();
    const { pathname } = window.location;

    const handleRoutePress = useCallback(
        (menuItem: MenuConfigurationItem) => {
            const screen = TEMPLATE_TO_ROUTE[menuItem.name as RootTemplates];
            const onTheSamePage =
                pathname.split('/').pop() ===
                TEMPLATE_TO_PATHNAME[menuItem.name as RootTemplates];

            if (menuItem.type === MenuItemType.EPG) {
                dispatch(setFocusToNow(true));
            }

            if (onTheSamePage) {
                navigation.replace(screen, { id: menuItem.id });
            } else {
                navigation.push(screen, { id: menuItem.id });
            }
        },
        [navigation, pathname],
    );

    return (
        <View
            style={[gStyles.headerContainer, gStyles.flexRow, styles.container]}
        >
            <View style={gStyles.flexRow}>
                {tabs.map((tab) =>
                    TEMPLATE_TO_ROUTE[tab.name as RootTemplates] ? (
                        <MainMenuItemWeb
                            key={tab.name}
                            tab={tab}
                            pathname={pathname}
                            onPress={handleRoutePress}
                        />
                    ) : null,
                )}
            </View>
        </View>
    );
};

export default RootNavigationHeaderCenter;
